'use strict';
var Fp = require('fp/app');
const helpers = require('../common/helpers');

module.exports = class jourParJour extends Fp {
	constructor(config) {
		super();
		this.config = config;
		this.sessionStorageIndexDayActif = 'jpjActif';
		this.dayArticleSelector = '.jpj__jour';
		this.itemsJour = document.querySelector('.fp__jpj > nav').children;
		this.container = document.querySelector('.basicLightbox__placeholder');
		this.errorMsg = {
			'goBeforeFirstDay': `C'est le premier jour`,
			'goAfterLastDay': `C'est le dernier jour`
		}
	}
	/**
	 * Initialisation du JPJ (au click sur <plus de détail>) depuis EventAction.js
	 * @param {int} index représente l'index du jour actif
	 * @param {string} lightbox correspond à la classe de la lightbox du JPJ
	 */
	initialize(index) {		
		let self = this;

		//!  KO BUG CHROME (stackoverflow 49318497) : Chrome ne sait pas gérer deux scrollIntoView() simultanée
		// Lorsque la popin du JPJ s'ouvre
		// On scrolle jusqu'au jour sur lequel on a cliqué en ouvrant la popin
		this.goTo(index)
		.then(() => {
			self.scrollEvent();
		})
		
		/// Listener events (click & scroll)
		self.clickEvent();
		self.eventDayChange();

		
	}

	scrollEvent(){
		let self = this,
		dayShow = self.getIndexjourActif;

		const observer = new IntersectionObserver(entries => {
			entries.forEach(elem => {
				if (elem.isIntersecting) {
					dayShow = parseInt(elem.target.parentElement.dataset.index);					
					helpers.setActiveItemInactiveSiblings(self.itemsJour, self.itemsJour[dayShow], ''); // On active le jour courant dans la <nav>
					self.saveIndexjourActif = dayShow; // on sauvegarde le jour actif

					// On distache l'événement lorsque l'on change de jour
					// on passe en paramètre l'index du jour actif
					elem.target.dispatchEvent(
						new CustomEvent('dayChanged', {
							bubbles: true,
							detail: {
								libelle: () => {
									return self.getIndexjourActif
								}
							}
						})
					);
				}
			});		
		});
		document.querySelectorAll(`${this.dayArticleSelector} .fp__titre`).forEach(elem => observer.observe(elem));
	}

	/**
	 * Lorsque l'événement 'dayChanged' a lieu on scroll la nav sur le jour actif après 800ms
	 */
	eventDayChange() {
		let self = this;
		this.container.addEventListener('dayChanged', (e) => {
			setTimeout(() => {
				self.itemsJour[e.detail.libelle()].scrollIntoView({
					behavior: 'smooth',
					inline: 'center'
				})
			},800)		
		})
	}

	/**
	 * 
	 * @param {int} day 
	 * Cette function scroll le JPJ jusu'au jour cliqué et mets la nav à jour via le listener eventDayChange
	 */
	goTo(day) {
		let self = this;
		return new Promise((resolve) => {			
			function callback() {
				self.container.children[day].scrollIntoView({
					behavior: 'smooth'
				});
				self.saveIndexjourActif = day;
				resolve(day)
			}
			helpers.setActiveItemInactiveSiblings(this.itemsJour, this.itemsJour[day], callback);
		});
	}

	/**
	 * CLICK NAV
	 */
	clickEvent() {
		let self = this;
		for (const iterator of this.itemsJour) {
			iterator.addEventListener('click', function () {
				let click = new Promise((resolve) => {			
					let index = parseInt(iterator.dataset.indexDay);
					self.container.children[index].scrollIntoView({
						behavior: 'smooth'
					});
					self.saveIndexjourActif = index;
					setTimeout(() => {
						resolve(index)
					},1000)				
				});
				click.then((day) => {
					self.itemsJour[self.getIndexjourActif].scrollIntoView({
						behavior: 'smooth',
						inline: 'center'
					});
				})
			})
		}
	}

	/**
	 *	SETTER
	 *  on sauvegarde l'index du jour actif
	 */
	set saveIndexjourActif(i) {
		window.sessionStorage.setItem(this.sessionStorageIndexDayActif, i)
	}

	/**
	 *	GETTER
	 *  on récupère l'index du jour actif
	 */
	get getIndexjourActif() {
		return parseInt(window.sessionStorage.getItem(this.sessionStorageIndexDayActif))
	}
}